/**
 * @file DeviceVisibilityField.tsx
 * @description «Показывать: Телефон · Планшет · ПК» (phase19.16 Р2;
 * uiux-design-r2 §2, §4, §10). У секции значение — «показывать» (true —
 * видно), у элемента — «скрыть» (`hide`), поле принимает «показывать» и
 * переводит само. Сняты все устройства — предупреждение.
 * Р2а: `lockedReason` — обязательный элемент шаблона товара: снять галочку
 * нельзя (причина под ними); показано фактическое состояние — если в данных
 * устройство скрыто (старые данные), его можно только включить.
 */

import { Label } from "../../../ui/label";
import { CheckRow } from "../../../site-view/CheckRow";
import { DEVICES, type DeviceFlags } from "../../../../lib/site-builder/devices";

export const NOWHERE_TEXT = "Блок не будет виден нигде — оставьте хотя бы одно устройство или скройте блок целиком.";

interface Props {
  /** Где показывать (true — видно). */
  value: DeviceFlags;
  onChange: (value: DeviceFlags) => void;
  /** Почему менять нельзя; `null` — можно. */
  lockedReason?: string | null;
}

export function DeviceVisibilityField({ value, onChange, lockedReason = null }: Props) {
  const nowhere = !value.phone && !value.tablet && !value.desktop;
  if (lockedReason) {
    return (
      <div className="flex flex-col gap-1">
        <Label>Показывать</Label>
        <div className="flex flex-wrap gap-x-4">
          {DEVICES.map((d) => (
            <CheckRow key={d.key} checked={value[d.key]} disabled={value[d.key]} onChange={(on) => on && onChange({ ...value, [d.key]: true })}>
              {d.label}
            </CheckRow>
          ))}
        </div>
        <p className="type-caption text-on-surface-variant">{lockedReason}</p>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-1">
      <Label>Показывать</Label>
      <div className="flex flex-wrap gap-x-4">
        {DEVICES.map((d) => (
          <CheckRow key={d.key} checked={value[d.key]} onChange={(on) => onChange({ ...value, [d.key]: on })}>
            {d.label}
          </CheckRow>
        ))}
      </div>
      {nowhere ? <p className="type-caption text-warning">{NOWHERE_TEXT}</p> : null}
    </div>
  );
}
